/*
 * On-page scoped-finder behaviour for the /support/ and /search/ pages.
 *
 * - The scoped finder (.finder) uses custom Bootstrap dropdowns for the
 *   product and category scope; picking an option sets the hidden field and
 *   GET-submits the form. Switching product clears the category (it may not exist
 *   for the new product).
 * - A committed search is logged via navigator.sendBeacon to the URL carried in
 *   the #ls-search-log payload. It fires on cache hits too, so popular queries are
 *   counted even when the cached results page skips the server view.
 *
 * The live-results dropdown is handled by live-search.js; the global ⌘K search
 * overlay (and the "/" / Cmd-K shortcuts) by search-overlay.js.
 */
(function () {
    // --- Scoped finder: custom dropdowns ---------------------------------
    // Bound to the /support/ + /search/ finder and the content listing toolbar
    // forms; never to other reusers of the .finder styling that aren't
    // forms and filter client-side instead (e.g. the resellers country picker).
    document.querySelectorAll('form.finder, form.content-toolbar').forEach(function (form) {
        // Bootstrap drives the dropdowns (open/close, keyboard, ARIA, position);
        // this only applies the picked scope: set the hidden field and submit.
        var catInput = form.querySelector('[data-finder-dd="category"] input[type="hidden"]');
        form.querySelectorAll('[data-finder-dd] .finder-dd-opt').forEach(function (opt) {
            opt.addEventListener('click', function () {
                var dd = opt.closest('[data-finder-dd]');
                dd.querySelector('input[type="hidden"]').value = opt.getAttribute('data-val');
                if (dd.getAttribute('data-finder-dd') === 'product' && catInput) catInput.value = '';
                // A search-only scope (e.g. the help guide filter) has no standalone
                // browse view, so picking it with an empty search box would just
                // reload the same page. Set the scope in place instead - update the
                // button label and active option client-side - and let the next live
                // search / submit pick it up.
                var qInput = form.querySelector('input[name="q"]');
                if (dd.hasAttribute('data-scope-search-only') && !(qInput && qInput.value.trim())) {
                    var label = dd.querySelector('.finder-dd-text');
                    var name = opt.querySelector('.finder-dd-oname');
                    if (label && name) label.textContent = name.textContent;
                    dd.querySelectorAll('.finder-dd-opt').forEach(function (o) {
                        o.classList.toggle('active', o === opt);
                    });
                    return;
                }
                form.submit();
            });
        });

        // Clear (×) button for plain search boxes (e.g. the content listing
        // toolbar). Forms with data-live-search get this from live-search.js.
        if (!form.hasAttribute('data-live-search')) {
            var input = form.querySelector('input[name="q"]');
            // A non-empty initial value means the page is filtered by a
            // server-side query, so clearing must re-submit to drop it
            // (keeping the other scopes), not just empty the box.
            var hadServerQuery = !!(input && input.value);
            lsWireSearchClear(input, form.querySelector('.ls-search-clear'), function () {
                if (hadServerQuery) form.submit(); else input.focus();
            });
        }
    });

    // --- Instant tooltips for icon-only links (e.g. the browse chips) -----
    if (window.bootstrap && bootstrap.Tooltip) {
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
            new bootstrap.Tooltip(el, { delay: 0, trigger: 'hover focus' });
        });
    }

    // --- Log the committed search (fires on cache hits too) --------------
    var payloadEl = document.getElementById('ls-search-log');
    if (payloadEl && navigator.sendBeacon) {
        try {
            var p = JSON.parse(payloadEl.textContent);
            if (p.url) {
                var body = new URLSearchParams();
                body.set('q', p.q || '');
                if (p.type) body.set('type', p.type);
                if (p.product) body.set('product', p.product);
                if (p.container) body.set('container', p.container);
                navigator.sendBeacon(p.url, body);
            }
        } catch (e) { /* analytics is best-effort */ }
    }
})();
